export default __webpack_public_path__ + "static/media/homepage-image.50878e45.png";